import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../Login";
import { authKey_local_storage_key } from "../../helpers/common";

const LoginPage = () => {
  const navigate = useNavigate();

  const [openLoginModal, setOpenLoginModal] = React.useState(false);
  const handleLoginOpen = () => setOpenLoginModal(true);
  const handleLoginClose = () => {
    setOpenLoginModal(false);
    navigate("/");
  };

  const authToken = localStorage.getItem(authKey_local_storage_key);

  useEffect(() => {
    if (authToken) {
      navigate("/profile");
    } else {
      setOpenLoginModal(true);
    }
  }, [navigate, authToken]);

  return (
    <div style={{ minHeight: "50vh" }}>
      <Login
        openModal={openLoginModal}
        handleOpen={handleLoginOpen}
        setOpenModal={setOpenLoginModal}
        handleClose={handleLoginClose}
      />
    </div>
  );
};

export default LoginPage;
